import { render, staticRenderFns } from "./CalendarBody.vue?vue&type=template&id=288311d4&scoped=true&"
import script from "./CalendarBody.vue?vue&type=script&lang=js&"
export * from "./CalendarBody.vue?vue&type=script&lang=js&"
import style0 from "./CalendarBody.vue?vue&type=style&index=0&id=288311d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288311d4",
  null
  
)

export default component.exports